import moment from "moment";

export function String__Slug(name) {
  const dashedString = name.toLowerCase().replace(/\\s/g, "-");
  const timestamp = moment()
    .unix()
    .toString();
  return `${dashedString}-${timestamp}`;
}
